<template>
  <div style="padding: 8px 30px">
    <el-form
      :inline="true"
      class="search-form"
      :model="search"
      @submit.prevent.stop="searchClick"
    >
      <el-form-item label="关键字">
        <el-input
          v-model="search.key"
          clearable
          placeholder="订单编号/商品名称"
          style="width: 200px"
          @keyup.enter="searchClick"
        />
      </el-form-item>
      <el-form-item label="日期范围">
        <el-date-picker
          v-model="search.dateRange"
          type="daterange"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 260px"
        />
      </el-form-item>
      <el-form-item label="返佣状态">
        <el-select
          v-model="search.txZt"
          clearable
          placeholder="全部"
          style="width: 120px"
        >
          <el-option label="未提现" :value="-1" />
          <el-option label="提现中" :value="0" />
          <el-option label="已提现" :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchClick">搜索</el-button>
        <el-button @click="resetClick">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 汇总信息 -->
    <div class="summary-bar">
      <el-tag type="info" size="large" effect="plain">
        总返佣：<b>¥{{ summary.TotalFy || "0.00" }}</b>
      </el-tag>
      <el-tag type="primary" size="large" effect="plain" style="margin-left: 10px">
        提现中：<b>¥{{ summary.TxzFy || "0.00" }}</b>
      </el-tag>
      <el-tag type="success" size="large" effect="plain" style="margin-left: 10px">
        已提现：<b>¥{{ summary.YtxFy || "0.00" }}</b>
      </el-tag>
      <el-tag type="warning" size="large" effect="plain" style="margin-left: 10px">
        待提现：<b>¥{{ summary.WtxFy || "0.00" }}</b>
      </el-tag>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="table.data"
      v-loading="table.loading"
      stripe
      size="small"
      style="margin-top: 12px"
    >
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="Bh" label="订单编号" min-width="160" show-overflow-tooltip />
      <el-table-column prop="Zt" label="订单状态" width="80" align="center" />
      <el-table-column prop="KhMc" label="分销商" min-width="140" show-overflow-tooltip />
      <el-table-column prop="SpMc" label="商品名称" min-width="160" show-overflow-tooltip />
      <el-table-column prop="SpPlMc" label="商品品类" width="100" align="center" />
      <el-table-column prop="SpTcMc" label="套餐名称" min-width="100" show-overflow-tooltip />
      <el-table-column prop="Xszj" label="销售总价" width="100" align="right" />
      <el-table-column label="返佣金额" width="100" align="right">
        <template #default="{ row }">
          <span style="color: #e6a23c; font-weight: bold">¥{{ row.FenXiaoJsJg }}</span>
        </template>
      </el-table-column>
      <el-table-column label="返佣状态" width="90" align="center">
        <template #default="{ row }">
          <el-tag v-if="row.FenXiaoTxZt === 1" type="success" size="small">已提现</el-tag>
          <el-tag v-else-if="row.FenXiaoTxZt === 0" type="primary" size="small">提现中</el-tag>
          <el-tag v-else type="warning" size="small">未提现</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="Cjsj" label="提交时间" width="160" align="center" />
      <el-table-column label="返佣时间" width="160" align="center">
        <template #default="{ row }">
          {{ row.FenXiaoTxSj || "-" }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div style="display: flex; justify-content: flex-end; margin-top: 12px">
      <el-pagination
        v-model:current-page="table.page"
        :page-size="table.limit"
        :total="table.total"
        layout="total, prev, pager, next"
        @current-change="pageChange"
      />
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted } from "vue";
import { caiwu_fenxiao_fanyong } from "@/http/api";

const search = reactive({
  key: "",
  dateRange: null,
  txZt: null,
});

const summary = reactive({
  TotalFy: "0.00",
  TxzFy: "0.00",
  YtxFy: "0.00",
  WtxFy: "0.00",
});

const table = reactive({
  data: [],
  total: 0,
  page: 1,
  limit: 20,
  loading: false,
});

const buildParams = () => {
  const p = { page: table.page, limit: table.limit };
  if (search.key) p.key = search.key;
  if (search.txZt != null) p.txZt = search.txZt;
  if (search.dateRange && search.dateRange.length === 2) {
    p.startDate = search.dateRange[0];
    p.endDate = search.dateRange[1];
  }
  return p;
};

const fetchData = async () => {
  table.loading = true;
  try {
    const res = await caiwu_fenxiao_fanyong(buildParams());
    if (res?.data) {
      table.data = res.data.data || [];
      table.total = res.data.total || 0;
      if (res.data.summary) {
        summary.TotalFy = res.data.summary.TotalFy || "0.00";
        summary.TxzFy = res.data.summary.TxzFy || "0.00";
        summary.YtxFy = res.data.summary.YtxFy || "0.00";
        summary.WtxFy = res.data.summary.WtxFy || "0.00";
      }
    }
  } finally {
    table.loading = false;
  }
};

const searchClick = () => {
  table.page = 1;
  fetchData();
};

const resetClick = () => {
  search.key = "";
  search.dateRange = null;
  search.txZt = null;
  table.page = 1;
  fetchData();
};

const pageChange = (page) => {
  table.page = page;
  fetchData();
};

onMounted(() => {
  fetchData();
});
</script>

<style scoped>
.search-form {
  background: #fff;
  padding: 16px 16px 0;
  border-radius: 6px;
  margin-bottom: 0;
}
.summary-bar {
  background: #fff;
  padding: 10px 16px;
  border-radius: 6px;
  margin-top: 12px;
}
</style>
